import { render } from "./CategoryCap.vue?vue&type=template&id=7091ecd4&lang=pug"
import script from "./CategoryCap.vue?vue&type=script&lang=js"
export * from "./CategoryCap.vue?vue&type=script&lang=js"

import exportComponent from "/builds/chiedocover/chiedohome.com/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__